import { z } from 'zod';


export const supportFormSchema = z.object({
    name        : z.string().trim().min(1, 'Name is required'),
    email       : z.string().min(1, 'Email is required').pipe(z.email('Invalid email')),
    company_name: z.string().trim().min(1, 'Company name is required'),
    contact_type: z.string().min(1, 'Contact type is required'),
    description : z.string().trim().min(1, 'Description is required'),
});

export type SupportFormInput = z.infer<typeof supportFormSchema>;
